export default __webpack_public_path__ + "static/media/debora.c74ed05f.png";